<template>
    <v-card max-width="340" height="100%" style="position:relative;" @click="selectionCas()">
        <v-img :src="cas.Image"
               class="white--text"
               height="200px"
               gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.2)"
               lazing-src="../assets/default_image.png">
            <template v-slot:placeholder>
                <v-row class="fill-height ma-0"
                       align="center"
                       justify="center">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-row>
            </template>
        </v-img>
        <v-card-title style="min-height:73px">
            <div class="title block-with-text-title" style="word-break: break-word;line-height:normal">{{cas.Titre}}</div>
        </v-card-title>
         <v-card-text style="min-height:180px">
             <div class="block-with-text"><span class="font-weight-bold">{{ GetTrad(95) }} :</span> {{cas.EntrepriseUtilisatrice ? cas.EntrepriseUtilisatrice : 'N/A'}}</div>
             <div class="block-with-text"><span class="font-weight-bold">{{ GetTrad(94) }} :</span> {{cas.EntrepriseDeveloppeuse ? cas.EntrepriseDeveloppeuse : 'N/A'}}</div>
             <template v-if="cas.SecteurActiviteIcone && cas.SecteurActiviteIcone.length > 0">
                 <div><span class="font-weight-bold">{{ GetTrad(90) }} :</span><v-img v-for="icon in cas.SecteurActiviteIcone" :key="icon" :src="icon" style="display:inline-block;vertical-align:middle;margin-bottom: 0.20em;margin-right:0.20em" width="24" max-height="30"></v-img></div>
             </template>
         </v-card-text>
        <v-card-actions style="position:absolute;bottom:0px;width:100%;min-height:76px">
            <v-row>
                <v-col align="center"
                       justify="center">
                    <v-btn color="#71BF4B" dark>
                        {{ GetTrad(101) }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'CasUtilisation',
        props: {
            cas: null
        },
        computed: {
            ...mapGetters({ GetTrad: 'Traduction/GET_BY_ID' }),
        },
        methods: {
            selectionCas: function () {
                this.$emit('selectionnerCas', this.cas)
            }
        }
    }
</script>

<style>
    @media only screen and (max-width:500px) {
        #cardAction {
            display: none;
        }
    }

    .theme--light.v-card > .v-card__text {
        color: black !important;
    }

    /* styles for '...' */
    .block-with-text-title {
        /* hide text if it more than N lines  */
        overflow: hidden;
        /* for set '...' in absolute position */
        position: relative;
        /* use this value to count block height */
        line-height: 1.2em;
        /* max-height = line-height (1.2) * lines max number (3) */
        max-height: 4.8em;
        /* fix problem when last visible word doesn't adjoin right side  */
        /*text-align: justify;*/
        /* place for '...' */
        margin-right: -0.3em;
        padding-right: 1em;
    }
    /* create the ... */
    .block-with-text-title:before {
        /* points in the end */
        content: '...';
        /* absolute position */
        position: absolute;
        /* set position to right bottom corner of block */
        right: 0;
        bottom: 0;
    }
    /* hide ... if we have text, which is less than or equal to max lines */
    .block-with-text-title:after {
        /* points in the end */
        content: '';
        /* absolute position */
        position: absolute;
        /* set position to right bottom corner of text */
        right: 0;
        /* set width and height */
        width: 1em;
        height: 1em;
        margin-top: 0.2em;
        /* bg color = bg color under block */
        background: white;
    }

     /* styles for '...' */
    .block-with-text {
        /* hide text if it more than N lines  */
        overflow: hidden;
        /* for set '...' in absolute position */
        position: relative;
        /* use this value to count block height */
        line-height: 1.2em;
        /* max-height = line-height (1.2) * lines max number (3) */
        max-height: 2.4em;
        /* fix problem when last visible word doesn't adjoin right side  */
        /*text-align: justify;*/
        /* place for '...' */
        margin-right: -0.3em;
        padding-right: 1em;
    }
    /* create the ... */
    .block-with-text:before {
        /* points in the end */
        content: '...';
        /* absolute position */
        position: absolute;
        /* set position to right bottom corner of block */
        right: 0;
        bottom: 0;
    }
    /* hide ... if we have text, which is less than or equal to max lines */
    .block-with-text:after {
        /* points in the end */
        content: '';
        /* absolute position */
        position: absolute;
        /* set position to right bottom corner of text */
        right: 0;
        /* set width and height */
        width: 1em;
        height: 1em;
        margin-top: 0.2em;
        /* bg color = bg color under block */
        background: white;
    }
</style>